import type { QueryClient } from "@tanstack/react-query"
import { meQuery } from "@/sign-in/client.ts"

/*
 * An installed app on a phone is seldom launched afresh: the system freezes it when the Member
 * leaves and restores the page as it was when they come back, without loading it again or firing
 * a focus the query cache would hear. Their session may have ended meanwhile (signed out in another
 * tab, deactivated, expired), so the shell asks again who is signed in.
 */

/** Asks again who is signed in whenever the browser restores this page rather than loading it. */
export function askWhoOnResume(queryClient: QueryClient) {
  window.addEventListener("pageshow", (event) => {
    // A page loaded afresh is already asking; only a restored one (`persisted`) holds an old answer.
    if (event.persisted) void queryClient.refetchQueries({ queryKey: meQuery.queryKey })
  })
}
